import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-s3url',
  templateUrl: './create-s3url.component.html',
  styleUrls: ['./create-s3url.component.css']
})
export class CreateS3urlComponent implements OnInit {


  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  requestData = `
  curl -v 'https://api.optimusdrive.ai/vod/v1/customer/presign-url' \
  -H 'authorization: XXX' \
 --data-raw  '{
         "content_type": "application/octet-stream",
         "file_name": "Show.MOV",
         "file_key": ""
     }'
 
     `

     copyToClipBoard(url: string) {
      var txtArea = document.createElement('textarea');
      txtArea.id = 'txt';
      txtArea.style.position = 'fixed';
      txtArea.style.top = '0';
      txtArea.style.left = '0';
      txtArea.style.opacity = '0';
      txtArea.value = url;
      document.body.appendChild(txtArea);
      txtArea.select();
  
      try {
        var successful = document.execCommand('copy');
        if (successful) {
         this.copyButton = false;
         this.copiedButton = true;
    // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
        }
      } catch (err) {
      } finally {
        document.body.removeChild(txtArea);
      }
    }
  
    copyJsonToClipboard() {
      this.copyToClipBoard(this.requestData);
    }
  






  sucessData = `
  {
    "data": {
        "fileKeyPath": "vod/input/bc96e670-4450-42c1-a53c-5175182040e2/a7f3b116-088d-42e0-87c2-6a55b421f72b/Show.MOV",
        "presigned_url": "XXX"
    },
    "message": "Pre-Signed generated successfully"
}
 

  `

  Error5x = `
  {
    "message": "Internal server error"
  }
  `

  Error4x =`
  {
    "error": "Error",
    "message": "Providing FileKey is not supported for crunch managed user"
  }`

  Error42x =`
  {
    "error": "content_type is the required field",
    "message": "content_type is the required field"
  }`



  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `


}
